import React, { useState } from "react";
import adminStyle from "../admin.module.scss";
import { createAdminRecord } from "../../../services/admin.service";
import { AdminLevel, createAdmin } from "../types";
import showToast from "../../../utils/show.toast";

interface ICreateModal {
  setIsModalOpen(val: boolean): void;
}

export default function CreateAdminCard({ setIsModalOpen }: ICreateModal) {
  const [isLoading, setLoading] = useState<Boolean>(false);
  const [password, setPassword] = useState("");
  const [data, setData] = useState<createAdmin>({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    dateOfBirth: new Date(),
    adminType: AdminLevel.INITIAL,
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const generatePassword = () => {
    const newPassword = Math.random().toString(36).slice(-8);
    setPassword(newPassword);
    setData((prevData) => ({ ...prevData, password: newPassword }));
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const copyDetailsToClipboard = () => {
    const detailsToCopy = `
      First Name: ${data.firstName}
      Last Name: ${data.lastName}
      Email: ${data.email}
      Password: ${password}
      Date of Birth: ${data.dateOfBirth.toISOString().slice(0, 10)}
      Role: ${data.adminType}
    `;

    navigator.clipboard
      .writeText(detailsToCopy)
      .then(() => showToast("Admin details copied to clipboard!", true))
      .catch((err) => console.error("Failed to copy:", err));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (!data.email || !data.password || !data.firstName || !data.lastName) {
      showToast("Please fill out all required fields!", false);
      return;
    }

    try {
      await createAdminRecord(data);
      showToast("Admin record created successfully!", true);
      setIsModalOpen(false);
      setLoading(false);
    } catch (error: any) {
      const message =
        error?.message ||
        "Apologies, something went wrong. Please try again later!";
      showToast(message, false);
      setLoading(false);
    }
  };

  return (
    <div className={adminStyle.modalBackdrop}>
      <div className={adminStyle.modalContent}>
        <div className={adminStyle.modalHeader}>
          <h2>Create Admin</h2>
          <p
            onClick={handleModalClose}
            style={{ cursor: "pointer", fontSize: "16px" }}
          >
            X
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={adminStyle.formRow}>
            <label>
              First Name:{" "}
              <input
                type="text"
                name="firstName"
                className={adminStyle.input}
                value={data.firstName}
                onChange={handleChange}
                required
              />
            </label>
            <label>
              Last Name:{" "}
              <input
                type="text"
                name="lastName"
                className={adminStyle.input}
                value={data.lastName}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <label>
            Role:
            <select
              name="adminType"
              className={adminStyle.dropdown}
              value={data.adminType}
              onChange={handleChange}
              required
            >
              <option value={AdminLevel.BASIC}>Basic</option>
              <option value={AdminLevel.ROOT}>Root</option>
              <option value={AdminLevel.SUPER}>Super</option>
            </select>
          </label>

          <label>
            Email:{" "}
            <input
              type="email"
              name="email"
              className={adminStyle.input}
              value={data.email}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Password:{" "}
            <input
              type="text"
              name="password"
              className={adminStyle.input}
              value={password}
              readOnly
            />
          </label>
          <label>
            Date of Birth:{" "}
            <input
              type="date"
              name="dateOfBirth"
              className={adminStyle.input}
              value={data.dateOfBirth.toISOString().slice(0, 10)}
              onChange={(e) =>
                setData((prevData) => ({
                  ...prevData,
                  dateOfBirth: new Date(e.target.value),
                }))
              }
              required
            />
          </label>

          <p className={adminStyle.passwordGenerate} onClick={generatePassword}>
            Generate Password
          </p>

          <p
            className={adminStyle.copyButton}
            onClick={copyDetailsToClipboard}
            style={{ width: "100%", marginBottom: "0.5rem" }}
          >
            Copy Admin Details
          </p>

          <button
            type="submit"
            className={adminStyle.createButton}
            style={{ width: "100%", marginTop: "1rem" }}
          >
            Create
          </button>
        </form>
      </div>
    </div>
  );
}
